import { toLower } from 'lodash';
import { useTranslation } from 'next-i18next';
import { AppLanguage } from 'src/common/models/app-language';
import styles from './AppVideoPop.module.scss';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { fa } from 'make-plural';

const AppVideoPop = ({
    content,
    videoLink,
    videoPoster,
    isPopup = false,
    videoAutoPlay = false,
}: any) => {
    const { i18n } = useTranslation();
    const [videoSrc, setVideoSrc] = useState('');
    useEffect(() => {
        const lan = i18n.language === AppLanguage.zh_hk ? 'cht' : 'eng';
        const link = content ? content.VideoURL.value : videoLink;
        let poster = content ? content.VideoPoster.src : videoPoster;
        const autostart = content?.VideoAutoPlay?.value || videoAutoPlay;
        if (!poster?.startsWith('http')) {
            poster = `${location.origin}${poster}`;
        }
        const rf = location.href;
        setVideoSrc(
            `https://common.hkjc.com/videoplayer_v3/video-player-iframe_v3.aspx?rf=${rf}&videourl=${link}&bgcolor=ffffff&ismultiangle=false&lang=${lan}&autostart=${autostart}&qualitybtn=true&posterimage=${poster}&themecolor=D9AD00`
        );
    }, [content, i18n.language, videoAutoPlay, videoLink, videoPoster]);

    return (
        <div className={styles.container}>
            {content && <div className={styles.title}>{content.VideoTitle.value}</div>}

            <div className={classNames(styles['video-container'], !isPopup && styles['out-pop'])}>
                <iframe
                    width='100%'
                    height='auto'
                    className={styles['iframe-container']}
                    allowFullScreen={true}
                    src={videoSrc}
                ></iframe>
            </div>
        </div>
    );
};

export default AppVideoPop;
